/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFromLocalStorage } from '../../../../../components/helper/authorizationHelper';
import { getAsync } from '../../../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../../../shared/Helper';
import Userbanner from '../../../../../components/elements/Userbanner';
import LoadingAnimation from '../../../../../components/LoadingAnimation';


const GWARegisterList = () => {
  const [apiData, setApiData] = useState([]);
  const [epUserID, setEpUserID] = useState(null);
  const [isload, setIsload] = useState(true);
  
  const {pathname} = useLocation()
  const navigate = useNavigate();
  const { t } = useTranslation();

  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token && !epUserID) {
      window.location.href = '/donorLogin';
    }
  };

  const getData = () => {
    setIsload(true);
    getAsync(
      'GWAService/GetGWAServiceByEPUserId',
      {
        id: epUserID,
      },
      'application/json',
    )
      .then((response) => {
        if (response) {
          setApiData(response?.data);
          setIsload(false);
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    isLogin();
    if (epUserID !== null) {
      getData();
      PageHitCountApi(pathname,epUserID);
    }
    // eslint-disable-next-line
  }, [epUserID]);

 

  // service not register
  if (!apiData.length && !isload) {
    navigate('/GWARegister');
  }

  // route user to UpdateGWARegister
  const handleRoute = (id) => {
    navigate('/ViewGWARegister', { state: { id: id } });
  };

  return (
    <div className="pt-12 ">
      {!isLogin ? (
        <h1>{t('Not Authorized')}</h1>
      ) : (
        <>
          <Userbanner />

          <div className="container-fluid">
            <div className="flex flex-col justify-center items-center">
              <div className=" ">
                <div className=" flex justify-center text-center">
                  <h1 className="font-bold sm:text-2xl text-xl text-customgreen">{t('Registration')}</h1>
                </div>
              </div>

              <div className={`col-lg-12 `}>
                {isload ? (
                  <LoadingAnimation
                    imageStyling={' py-20 '}
                    styling={'flex items-center   align-middle justify-center space-x-2'}
                  />
                ) : (
                  <>
                    {apiData[0]?.activeID === 1 ? (
                      <div className="flex py-10 flex-wrap justify-center">
                        {apiData.map((item, index) => (
                          <div
                            key={index}
                            className={`bg-green-100 shadow-md justify-start rounded-lg p-6 m-4`}
                            style={{ width: 'calc(100% - 2rem)', maxWidth: '300px' }}
                          >
                            <div className="text-gray-700 mb-2">
                              <span className="font-semibold">{t('Full Name')}:</span> {item.fullName}
                            </div>
                            <div className="text-gray-700 mb-2">
                              <span className="font-semibold">{t(`Date`)}:</span> {item.date}
                            </div>
                            <div className="text-gray-700 mb-2">
                              <span className="font-semibold">{t('Time Now')}:</span> {item.timeNow}
                            </div>
                            <div className="text-gray-700 mb-4">
                              <span className="font-semibold">{t('Status')}:</span>{' '}
                              {t(
                                `${item.maApproveID === 1 ? 'Approved' : item.maApproveID === 2 ? 'Disapproved' : 'Pending'}`,
                              )}
                            </div>
                            {/* <Link to={`/UpdateGWARegister/${item?.epUserID}`}>
                                <button className="bg-customgreen text-white py-2 px-4 hover:bg-hovergreen w-1/3 rounded-xl">

                                  {t('Edit')}
                                </button>
                              </Link> */}
                            <button
                              onClick={() => handleRoute(item?.epUserID)}
                              className="text-white bg-customgreen hover:bg-hovergreen   rounded-full  px-4 py-2 me-2 text-center"
                            >
                              {t('View')}
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex justify-center">
                        <p className="pt-14 pb-12 font-bold sm:text-2xl text-xl text-customgreen">
                          {'Service inactivated. Contact the admin.'}
                        </p>
                      </div>
                    )}

                    {/* {datanotfound && <DataNotFound />} */}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GWARegisterList;
